export const getTimestamp = () => {
  return (new Date).getTime();
};
